const currencyFilterMixin = {
  filters: {
    currencyBRL(value = 0) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
    },
    currency(value, { codeCurrency = 'BRL', signDisplay = 'never' }) {
      const mapperCodeToLocale = {
        MXN: 'es-US',
        CLP: 'es-US',
        COP: 'es-US',
        BRL: 'pt-BR',
      }

      return new Intl.NumberFormat(mapperCodeToLocale[codeCurrency], {
        style: 'currency',
        currency: codeCurrency || 'BRL',
        minimumFractionDigits: 2,
        signDisplay,
      }).format(value)
    },
  },
}

export default currencyFilterMixin
